import { useEffect, useRef } from "react";
import "./style.scss";

const PaymentTypeModal = ({
  open,
  onClose,
  options = [],
  tr = (s) => s,
  onSelect, // (opt) => void
}) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const list = Array.isArray(options) ? options : [];

  return (
    <div
      className="ptm__overlay"
      ref={overlayRef}
      onClick={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
    >
      <div className="ptm__sheet">
        <div className="ptm__title">{tr("Выберите тип оплата")}</div>

        <div className="ptm__grid">
          {list.map((opt) => (
            <button
              key={String(opt.id ?? opt.name)}
              className="ptm__item"
              onClick={() => onSelect?.(opt)}
              title={opt.name}
            >
              <div className="ptm__icon" aria-hidden>
                <img
                  src={opt?.logo}
                  style={{ width: "150px", height: "70px" }}
                  alt=""
                />
              </div>
            </button>
          ))}
        </div>

        <button className="ptm__close" onClick={onClose}>
          {tr("Отмена")}
        </button>
      </div>
    </div>
  );
};

export default PaymentTypeModal;
